import styled from 'styled-components';

function ServiceCard() {
  return (
    <Column gap={40}>
      <Content_Wrap>
        <li>
          <img
            src="/assets/images/promotion/Content1_2.png"
            alt=""
            style={{ position: 'absolute', right: 30.4, bottom: 0 }}
          />
          <img
            src="/assets/images/promotion/Content1_1.png"
            alt=""
            style={{ position: 'absolute', bottom: 55, right: 6.25 }}
          />
          <Content_Text>
            <Content_Sub_title>
              <h3>
                다양한 경공매 물건 검색 기능
                <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
                <br />
                <UnderLine>지도 검색</UnderLine> 가능
              </h3>
            </Content_Sub_title>
            <Content_Description>
              <span>땅집고옥션에서 간편하게 경공매를 분석해보세요</span>
              <span>지도로 검색해 직관적인 비교, 분석이 가능합니다.</span>
            </Content_Description>
          </Content_Text>
        </li>
      </Content_Wrap>

      <Content_Wrap>
        <li>
          <img
            src="/assets/images/promotion/free-trial-ai.png"
            alt=""
            style={{ position: 'absolute', top: 104, left: '-42px' }}
            width={404}
            height={605}
          />
          <Content_Text>
            <Content_Sub_title>
              <h3>
                AI가 찾아주는
                <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
                <br />
                <UnderLine>경공매 물건 찾기</UnderLine>
              </h3>
            </Content_Sub_title>
            <Content_Description>
              <span>AI와 대화하듯 물건을 찾아보세요</span>
              <span>유찰횟수, 지하철역, 초등학교 근처 등 </span>
              <span>다양한 조건으로 검색이 가능합니다.</span>
            </Content_Description>
          </Content_Text>
        </li>
      </Content_Wrap>

      <Content_Wrap>
        <li>
          <img
            src="/assets/images/promotion/Content2_4.png"
            alt=""
            style={{
              position: 'absolute',
              top: 184,
              left: '-4px',
            }}
            width={240}
            height={418}
          />
          <img
            src="/assets/images/promotion/Content2_5.png"
            alt=""
            style={{
              position: 'absolute',
              top: 204,
              left: 174,
            }}
            width={120}
            height={187}
          />

          <Content_Text>
            <Content_Sub_title>
              <h3>
                내 <UnderLine>알고리즘 분석</UnderLine>
                <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
              </h3>
              <h3>추천 기능</h3>
            </Content_Sub_title>
            <Content_Description>
              <span>
                나만의 경매 성공공식,
                <br />
                AI 알고리즘을 만들어보세요.
                <br />
                빅데이터 기반으로 경공매
                <br />
                투자 의사 결정을 지원합니다.
              </span>
            </Content_Description>
          </Content_Text>
        </li>
      </Content_Wrap>

      <Content_Wrap>
        <li>
          <img
            src="/assets/images/promotion/Content3_4.png"
            alt=""
            style={{
              position: 'absolute',
              right: 30.15,
              bottom: 0,
            }}
          />
          <img
            src="/assets/images/promotion/Content3_1.png"
            alt=""
            style={{
              position: 'absolute',
              right: 168.9,
              bottom: 111,
              width: '131.1px',
            }}
          />
          <img
            src="/assets/images/promotion/Content3_2.png"
            alt=""
            style={{
              position: 'absolute',
              right: 124.9,
              bottom: 18,
              width: '131.1px',
            }}
          />
          <img
            src="/assets/images/promotion/Content3_3.png"
            alt=""
            style={{
              position: 'absolute',
              right: 33,
              bottom: 65,
              width: '131.1px',
            }}
          />

          <Content_Text>
            <Content_Sub_title>
              <h3>
                돈되는 테마주
                <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
              </h3>
              <h3>
                <UnderLine>퀀트 투자</UnderLine>
              </h3>
            </Content_Sub_title>
            <Content_Description>
              <span>AI경공매 퀀트 분석을 통해</span>
              <span>12개의 퀀트 전략을 제공합니다.</span>
              <span>시세보다 저평가된 물건부터</span>
              <span>시세차익 물건까지 추천해드립니다.</span>
            </Content_Description>
          </Content_Text>
        </li>
      </Content_Wrap>

      <Content_Wrap>
        <li>
          <img
            src="/assets/images/promotion/Content4_2.png"
            alt=""
            style={{
              position: 'absolute',
              right: 30,
              bottom: 0,
              width: '260px',
            }}
          />
          <img
            src="/assets/images/promotion/Content4_1.png"
            alt=""
            style={{
              position: 'absolute',
              right: 20.21,
              bottom: 92,
              width: '108.79px',
            }}
          />

          <Content_Text>
            <Content_Sub_title>
              <h3>약 40억건 데이터 학습 기반,</h3>
              <h3>
                <UnderLine>AI 분석 시스템</UnderLine>
              </h3>
            </Content_Sub_title>
            <Content_Description>
              <span>더이상 직감과 경험에 의존하지 마세요.</span>
              <span>
                땅집고옥션은 데이터로
                <br />
                투자 근거를 찾아드립니다!
              </span>
            </Content_Description>
          </Content_Text>
        </li>
      </Content_Wrap>
    </Column>
  );
}

export default ServiceCard;

const Column = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;

const Content_Wrap = styled.ul`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 0;
  margin: 0;

  li {
    position: relative;
    overflow: hidden;
    padding: 23px;
    height: 362px;
    background: #ffffff;
    border-radius: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    max-width: 335px;
  }
`;

const Content_Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Content_Sub_title = styled.div`
  h3 {
    margin: 0;
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 24px;
    line-height: 145%;
    letter-spacing: calc(24px * -0.02);
    text-align: center;
    span {
      font-family: Paperlogy;
    }
  }
`;

const Content_Description = styled.div`
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: calc(14px * -0.02);
    color: #616161;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const UnderLine = styled.span`
  background-image: linear-gradient(to top, #d6bdff 40%, transparent 40%);
  background-repeat: no-repeat;
  background-size: 110% 1em;
  background-position: 0 100%;
  font-family: Paperlogy;
`;
